module.exports = __webpack_public_path__ + "static/img/hero-card-logo.14d2516c.png";